/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */
const mobiusSocketConfig = {
    wssResponseTimeout: 10000,
    backoffTimeMax: 32000,
    backoffTimeReset: 1000,
    initialConnectionMaxRetries: 0,
    maxRetries: 0,
    forceCloseDelay: 2000,
    dedupCacheMaxSize: 1000,
};
export default {
    mobiusSocket: mobiusSocketConfig,
};
